/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Go_To_SettingsInputs */

const en_common_go_to_settings = /** @type {(inputs: Common_Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Settings`)
};

const es_common_go_to_settings = /** @type {(inputs: Common_Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a Ajustes`)
};

/**
* | output |
* | --- |
* | "Go to Settings" |
*
* @param {Common_Go_To_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_go_to_settings = /** @type {((inputs?: Common_Go_To_SettingsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Go_To_SettingsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_go_to_settings(inputs)
	return en_common_go_to_settings(inputs)
});